import { CHANNEL_DETAIL } from "../constants/action-types";

export const getChannelDetail = data => ({
         type: CHANNEL_DETAIL,
         payload: data
       });
